import { useMutation } from '@tanstack/react-query';
import { addNewDependent } from '../services/fn-api/Beneficiary';
import { IDependent } from '../types/Beneficiary';

export const useAddNewDependent = () => {
  return useMutation<IDependent, Error, Record<string, unknown>>({
    mutationFn: async (data) => {
      return addNewDependent(data);
    },
  });
};
